export const CHAT_VIEW_OPENED_GROUP_ID_LOCALSTORAGE = 'CHAT_VIEW_OPENED_GROUP_ID_LOCALSTORAGE';
export const CHAT_VIEW_OPENED_CHAT_ID_LOCALSTORAGE = 'CHAT_VIEW_OPENED_CHAT_ID_LOCALSTORAGE';
